import * as amplitude from '@amplitude/analytics-browser';

amplitude.init('b808d474222bc5b5900b7a3121ac3e41');

export const logEvent = (eventName, eventId) => {
  amplitude.track(eventName, {
    event_id: eventId,
  });
};
